import React from 'react';
import { useTranslation } from 'react-i18next';
import { ReactComponent as ShieldIcon } from '../../../assets/images/icons/compare_shield.svg';
import styles from './Rescue.module.scss';

interface RescueOfferBoxProps {
  /** Whether the selected plan charges an activation fee, which is all the copy needs to know. */
  hasActivationFee?: boolean;
  /** Whether the promo applies in the shopper's country. */
  showBadge?: boolean;
  /** Lets the pdp fire a viewed event the first time the box scrolls in. */
  containerRef?: React.RefObject<HTMLDivElement>;
}

/**
 * States what the adoption actually covers. The badge names the gift itself in neutral gray (yellow
 * stays reserved for the CTA), and it drops out entirely rather than claim an offer in a market
 * where it does not apply. This block exists because "6 months free" was previously only legible by
 * reading a struck-through price.
 */
export default function RescueOfferBox({ hasActivationFee, showBadge, containerRef }: RescueOfferBoxProps) {
  const { t } = useTranslation();

  return (
    <div className={styles.offerBox} ref={containerRef}>
      <div className={styles.offerTopRow}>
        <div className={styles.offerTitle}>{t('rescue_offer_title')}</div>
        {showBadge && (
          <div className={styles.offerBadge}>
            <ShieldIcon aria-hidden />
            {t('rescue_offer_badge')}
          </div>
        )}
      </div>
      {/* the amount is deliberately absent: the fee varies by market and quoting it here read as a
          price on an offer that is otherwise free */}
      <div className={styles.offerBody}>
        {hasActivationFee ? t('rescue_offer_body_with_fee') : t('rescue_offer_body')}
      </div>
    </div>
  );
}
